import axios from 'axios'

// state
const state = {
  isLoading: true,
  productDetails: {
    displayName: '',
    id: '',
    pdpUrl: '',
    defaultLevelOneCategory: {},
    pricedByWeight: true,
    randomWeight: true,
    formattedListPrice: '',
    formattedSalePrice: '',
    smallImageUrl: '',
    mediumImageUrl: '',
    thumbnailImageUrl: '',
    thumbnailMediumImageUrl: '',
    addToCartDisabled: true,
    addToCartAllowed: true,
    isPrimoPick: true,
    showOnlineMarketingBug: true,
    onSale: true,
    longDescription: '',
    servingText: '',
    guaranteeImageUrl: '',
    guaranteeImageCode: '',
    type: '',
    safetyWarning: '',
    preparationInstructions: '',
    safetyRegulatory: '',
    alcoholPercent: 0,
    defaultSku: {
      customerFriendlySize: '',
      displayName: '',
      id: '',
      onSale: true,
      thumbnailImageUrl: '',
      sceneSevenImage: '',
      unitOfMeasure: '',
      unitOfMeasureQuantity: 0,
      unitWeight: 0,
      customerPurchaseChoice: '',
      couponIds: [],
      weightSelectionMax: 0,
      fulfillmentType: '',
      isSupplementFact: '',
      ingredients: '',
      weightSelectionMin: 0,
      priceInfo: {
        priceType: '',
        listPrice: {
          formatted: '',
          unit: '',
          listPriceAmountRounded: ''
        },
        salePrice: {
          formatted: '',
          unit: ''
        },
        unitListPrice: {
          formatted: '',
          unit: ''
        },
        unitSalePrice: {
          formatted: '',
          unit: ''
        }
      },
      weightSelectionIncrements: [
        0
      ],
      nutritionSummaries: [
        {
          supplement: '',
          vitaminItems: [
            {
              percentDailyIntakeValue: '',
              nutritionValue: '',
              nutritionSequence: 0,
              isSupplement: true,
              nutritionUom: '',
              subProductDec: '',
              nutrition: {
                name: '',
                position: 0
              }
            }
          ],
          caloriesItems: [
            {
              percentDailyIntakeValue: '',
              nutritionValue: '',
              nutritionSequence: 0,
              isSupplement: true,
              nutritionUom: '',
              subProductDec: '',
              nutrition: {
                name: '',
                position: 0
              }
            }
          ],
          otherMineralItems: [
            {
              percentDailyIntakeValue: '',
              nutritionValue: '',
              nutritionSequence: 0,
              isSupplement: true,
              nutritionUom: '',
              subProductDec: '',
              nutrition: {
                name: '',
                position: 0
              }
            }
          ],
          servingSizeItem: {
            percentDailyIntakeValue: '',
            nutritionValue: '',
            nutritionSequence: 0,
            isSupplement: true,
            nutritionUom: '',
            subProductDec: '',
            nutrition: {
              name: '',
              position: 0
            }
          },
          servingSizeContainerItem: {
            percentDailyIntakeValue: '',
            nutritionValue: '',
            nutritionSequence: 0,
            isSupplement: true,
            nutritionUom: '',
            subProductDec: '',
            nutrition: {
              name: '',
              position: 0
            }
          },
          containItem: {
            percentDailyIntakeValue: '',
            nutritionValue: '',
            nutritionSequence: 0,
            isSupplement: true,
            nutritionUom: '',
            subProductDec: '',
            nutrition: {
              name: '',
              position: 0
            }
          }
        }
      ],
      coupons: [
        {
          appliedToOrder: true,
          bubbleCallOut: '',
          couponId: '',
          displayName: '',
          expirationDate: '',
          id: '',
          imageUrl: '',
          inStoreOnly: true,
          rewardLimit: '',
          termsAndConditions: '',
          unclipped: true,
          closenessQualifiers: [
            {
              callToAction: '',
              callToActionBuyDollarAmount: 0,
              callToActionBuyQuantityUnits: 0,
              name: '',
              percentComplete: 0
            }
          ]
        }
      ]
    },
    snipes: [
      {
        name: '',
        description: '',
        largeImageUrl: '',
        mediumImageUrl: '',
        position: 0
      }
    ],
    storeAssortment: {
      marketingBugKey: '',
      marketingBugDescription: '',
      smallImageMarketingBugUrl: ''
    },
    specificationValues: [
      {
        description: '',
        name: '',
        position: 0,
        value: ''
      }
    ]
  }
}

const actions = {
  GET_PRODUCT_DETAILS ({ commit }, obj) {
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')
    vm.commit('products/SET_LOADING', true)

    axios
      .all([
        axios.get(`/commerce-api/v1/product/${obj.productId}/details?storeId=${obj.storeId}`)
      ])
      .then(
        axios.spread((response) => {
          vm.commit('products/SET_PRODUCT_DETAILS', response.data)
          vm.commit('products/SET_LOADING', false)
        })
      )
      .catch((error) => {
        // Error
        vm.dispatch('errors/HANDLE_ERROR', error)
      })
  }
}

const mutations = {
  SET_PRODUCT_DETAILS (state, data) {
    state.productDetails = data
  },
  SET_LOADING (state, boolean) {
    this._vm.$set(state, 'isLoading', boolean)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
